<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Products'"></navbar>
			<!--导航-->
			<!--块1-->
			<!-- <div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="bg" src="../../assets/img_h5/蒙版组 7@2x.webp" />
				<div class="msg_box">
					<div class="tit">CorDx Products</div>
					<div class="txt">
						CorDx ensures a reliable supply of accurate, easy-to-use diagnostics products priced for all.
					</div>
				</div>
			</div> -->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">
					CorDx Products
				</div>
				<div class="txt" style="text-align: center;">
					CorDx develops diagnostic tests that medical professionals and families trust – then brings them to OTC and POC markets at scale through our own procurement, production and logistics processes. 
				</div>
				<div class="bg_box">
					<img src="../../assets/img_h5/20230912-085057.webp" />
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">
					Healthcare providers, request your free sample kit today:<br />CorDx Tyfast Flu A/B & COVID-19 Multiplex Test
				</div>
				<div class="btn_box_f">
					<div class="btn_box_ty btn_box" @click="goProduct7">
						Learn More
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div v-if="!isCateProduct" class="cate_box">
					<div class="tit">Categories</div>
					<div class="list_box">
						<div v-for="(value, index) in cateOptions" :key="index" class="list_el" @click="cateHandle(value)">
							<div class="list_el_main">
								<div class="left">
									<img :src="value.is_checked == 1 ? require('@/assets/img_h5/checked.png') : require('@/assets/img_h5/no_check.png') " />
								</div>
								<div class="right">
									{{ value.catname }}
								</div>
							</div>
							<template v-if="value.children.length > 0">
								<div v-for="(value1, index1) in value.children" :key="index1" class="list_el_child" @click.stop="cateHandle(value1)">
									<div class="list_el_main">
										<div class="left">
											<img :src="value1.is_checked == 1 ? require('@/assets/img_h5/checked.png') : require('@/assets/img_h5/no_check.png') " />
										</div>
										<div class="right">
											{{ value1.catname }}
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
				<div class="cate_box">
					<div class="tit">Product certifications</div>
					<div class="search_box">
						<input v-model="rzVal" placeholder="Search..." v-on:input="rzInput" />
					</div>
					<div class="list_box list_height">
						<div v-for="(value, index) in rzOptions" :key="index" class="list_el" @click="authHandle(1, value)">
							<div class="list_el_main">
								<div class="left">
									<img :src="value.is_checked == 1 ? require('@/assets/img_h5/checked.png') : require('@/assets/img_h5/no_check.png') " />
								</div>
								<div class="right">
									{{ value.catname }}
								</div>
							</div>
							<template v-if="value.children.length > 0">
								<div v-for="(value1, index1) in value.children" :key="index1" class="list_el_child" @click.stop="authHandle(2, value1)">
									<div class="list_el_main">
										<div class="left">
											<img :src="value1.is_checked == 1 ? require('@/assets/img_h5/checked.png') : require('@/assets/img_h5/no_check.png') " />
										</div>
										<div class="right">
											{{ value1.catname }}
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
				<div class="block_3_main">
					<div class="input_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<input v-model="searchVal" placeholder="Search Product" v-on:input="searchInput" />
						<div class="btn_box" @click="searchProduct">
							<van-icon name="search" size="20px" color="#ffffff" style="position: relative;top: 3px;font-weight: bold;" />
						</div>
					</div>
					<div v-if="searchData.length > 0" v-loading="searchLoading" class="search_list">
						<div>
							<div class="top_box"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="top_box_left">{{ searchPage }} Results</div>
								<div class="top_box_right">
									<van-pagination
										v-model="seatchCurrentPage"
										:items-per-page="5"
										:total-items="searchPage"
										mode="simple"
										@change="searchPageChange"
									>
										<template #prev-text>
											<van-icon name="arrow-left" />
										</template>
										<template #next-text>
											<van-icon name="arrow" />
										</template>
									</van-pagination>
								</div>
							</div>
							<div class="search_list_main">
								<div v-for="(value, index) in searchData" :key="index" class="search_el"
									
									@click="goProductInfo(value)"
								>
									<div class="search_el_left">
										<img :src="value.url" />
									</div>
									<div class="search_el_right">
										<div class="title">{{ value.title }}</div>
										<div class="text">{{ value.description }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<template v-else>
						<div v-if="searchVal != ''" class="search_list">
							<div style="padding: 20px 0;color: #999999;text-align: center;" class="search_box">
								<img src="../../assets/img_h5/search_no.png" />
							</div>
						</div>
					</template>
					<div v-if="productType.length > 0" class="tags"
						data-aos="fade-left"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div :class="nowTest == 'All' ? 'actived' : ''" @click="testHandle('All')">All</div>
						<div v-for="(value, index) in productType" :key="index" :class="nowTest == value.id ? 'actived' : ''" @click="testHandle(value.id)">{{ value.catname }}</div>
					</div>
					<div v-if="productData.length > 0" v-loading="productLoading" class="product_list">
						<div v-for="(value, index) in productData" :key="index" class="product_el"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							@click="goProductInfo(value)"
						>				
							<div class="bg_box">
								<img class="bg" :src="value.url" />
							</div>
							<div class="tit_box">
								<div class="tit">{{ value.title }}</div>
								<div class="icon">
									<img src="../../assets/img_h5/组 32@2x.png" />
								</div>
							</div>
							<div class="txt">{{ value.description }}</div>
						</div>
					</div>
					<div v-else style="padding: 20px 0;color: #999999;text-align: center;" class="search_box">
						<img src="../../assets/img_h5/search_no.png" />
					</div>
				</div>
			</div>
			<!--块3-->
			<div v-if="productData.length > 0" class="page_box">
				<el-pagination
					layout="prev, pager, next"
					:total="productPage"
					:page-size="6"
					@current-change="productPageChange"
				></el-pagination>
			</div>
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import { productCate, productCates, productAuth, productList, productSearch, productTest, } from '@/api/public_h5';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isShow: null,
			cateOptions: [],  //产品分类数据
			cateLoading: false,
			rzOptions: [],  //产品认证数据
			rzVal: '',  //产品认证搜索
			searchVal: '',  //产品搜索
			seatchCurrentPage: 1,  //产品搜索翻页
			isCateProduct: false,  //是否展示产品分类
			cateName: '',  //产品分类名
			cateIds: [],
			authIds: [],
			productData: [],
			productPage: 0,
			noPage1: 1,
			productLoading: false,
			searchData: [],
			searchPage: 0,
			noPage2: 1,
			searchLoading: false,
			nowTest: 'All',
			productType: [],
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		that.getProductCate('');  //请求产品分类
		that.getProductAuth('');  //请求产品认证
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//查询产品检测类型
		getProductTest() {
			let that = this;
			that.productType = [];
			that.nowTest = 'All';
			productTest({ custom: that.cateIds.join(','), language: sessionStorage.getItem('lang'), }).then(res => {
				that.productType = res.data;
			});
		},
		//检测途径点击
		testHandle(value) {
			let that = this;
			that.nowTest = value;
			that.noPage1 = 1;
			that.getProductList();
		},
		//产品输入搜索
		searchInput() {
			let that = this;
			if(that.searchVal != '') {
				that.noPage2 = 1;
				that.searchProductList();
			}else {
				that.noPage2 = 1;
				that.searchData = [];
				that.searchPage = 0;
			}
		},
		//产品搜索翻页
		searchPageChange(val) {
			let that = this;
			that.noPage2 = val;
			that.searchProductList();
		},
		//点击搜索产品
		searchProduct() {
			let that = this;
			if(that.searchVal != '') {
				that.noPage2 = 1;
				that.searchProductList();
			}else {
				that.noPage2 = 1;
				that.searchData = [];
				that.searchPage = 0;
			}
		},
		//产品搜索
		searchProductList() {
			let that = this;
			that.searchLoading = true;
			productSearch({
				keyword: that.searchVal,
				page: that.noPage2,
				page_size: 5,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.searchData = res.data.data;
				that.searchPage = res.data.total;
				that.searchLoading = false;
			});
		},
		//点击查看产品详情
		goProductInfo(value) {
			let that = this; // flu-a%2Fb-&-covid-19-multiplex-rapid-test cordx-tyfast-flu-a/b-&-covid-19-multiplex-rapid-test
			if(value.custom == 'flu-a/b-&-covid-19-multiplex-rapid-test') {
				that.$router.push({ name: 'Productsinfos', params: { productInfoIds: value.custom, } });
			}else if(value.custom == 'cordx-tyfast-flu-a-b-covid-19-at-home-rapid-multiplex-test-cordx') {
				that.$router.push({ name: 'Productsinfos2', params: { productInfoIds: value.custom, } });
			}else if(value.custom == 'cordx-tyfast-covid-19-ag-rapid-test') {
				that.$router.push({ name: 'Productsinfos3', params: { productInfoIds: value.custom, } });
			}else if(value.custom == 'cordx-tyfast-multi-drug-rapid-test-cup') {
				that.$router.push({ name: 'cordx-tyfast-multi-drug-rapid-test-cup' });
			}else if(value.custom == 'cordx-tyfast-rsv-rapid-test') {
				that.$router.push({ name: 'cordx-tyfast-rsv-rapid-test' });
			}else if(value.custom == 'cordx-tyfast-ovulation-test-pregnancy-test-combo') {
				that.$router.push({ name: 'cordx-tyfast-ovulation-test-pregnancy-test-combo' });
			}else if(value.custom == 'cordx-one-step-hcg-pregnancy-test-cassette') {
				that.$router.push({ name: 'cordx-one-step-hcg-pregnancy-test-cassette' });
			}else if(value.custom == 'cordx-tyfast-cotinine-cot-rapid-test') {
				that.$router.push({ name: 'cordx-tyfast-cotinine-cot-rapid-test' });
			}else if(value.custom == 'cordx-tyfast-fsh-rapid-test') {
				that.$router.push({ name: 'cordx-tyfast-fsh-rapid-test' });
			}else if(value.custom == 'cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc') {
				that.$router.push({ name: 'cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc' });
			}else {
				that.$router.push({ name: 'Productsinfo', params: { productInfoId: value.custom, } });
			}
		},
		//点击进入id=7的产品
		goProduct7() {
			let that = this;
			// that.$router.push({ path: '/products-info', query: { id: 16878442462384, } });
			// that.$router.push({ name: 'Productsinfo', params: { productInfoId: 'cordx-covid-19-ag-test', } });
			// window.location.href = 'https://pages.cordx.com/free-sample-kit';
			that.$router.push({ path: '/free-sample-kit', });
		},
		//产品列表分页
		productPageChange(val) {
			let that = this;
			that.noPage1 = val;
			that.getProductList();
		},
		//请求产品列表
		getProductList() {
			let that = this;
			that.productLoading = true;
			productList({
				custom: that.cateIds.join(','),
				cert_id: that.authIds.join(','),
				test_id: that.nowTest == 'All' ? '' : that.nowTest,
				page: that.noPage1,
				page_size: 6,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.productData = res.data.data;
				that.productPage = res.data.total;
				that.productLoading = false;
			});
		},
		//产品认证搜索
		rzInput() {
			this.authIds = [];
			this.getProductAuth();
		},
		//请求产品认证
		getProductAuth() {
			let that = this;
			productAuth({
				keyword: that.rzVal,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.rzOptions = res.data;
				//请求产品列表
				that.noPage1 = 1;
				that.getProductList();
			});
		},
		//请求产品分类
		getProductCate(id) {
			let that = this;
			that.cateLoading = true;
			that.cateIds = [];
			productCates({
				custom: id,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.cateOptions = res.data;
				that.cateLoading = false;
				that.cateOptions.forEach((value, index) => {
					if(value.is_checked == 1) {
						that.cateIds.push(value.custom);
					}
				});
				that.noPage1 = 1;
				that.nowTest = 'All';
				that.getProductList();
				that.getProductTest();
			});
		},
		//产品分类点击
		cateHandle(val) {
			let that = this;
			let dataArray = that.cateOptions;
			if(val.level == 1) {
				dataArray.forEach((value, index) => {
					if(value.id == val.id) {
						if(value.is_checked == 0) {
							that.getProductCate(val.custom);
						}else {
							that.getProductCate('');
						}
					}
				});
			}else {
				that.cateIds = [];
				dataArray.forEach((value, index) => {
					dataArray[index].is_checked = 0;
					value.children.forEach((value1, index1) => {
						if(value1.id == val.id) {
							if(value1.is_checked == 0) {
								dataArray[index].children[index1].is_checked = 1;
								that.cateIds.push(val.custom);
							}else {
								dataArray[index].children[index1].is_checked = 0;
							}
						}else {
							dataArray[index].children[index1].is_checked = 0;
						}
					});
				});
				that.noPage1 = 1;
				that.nowTest = 'All';
				that.getProductList();
				that.getProductTest();
			}
		},
		//产品认证点击
		authHandle(type, val) {
			let that = this;
			let dataArray = that.rzOptions;
			dataArray.forEach((value, index) => {
				if(value.id == val.id) {
					if(value.is_checked == 0) {
						dataArray[index].is_checked = 1;
					}else {
						dataArray[index].is_checked = 0;
					}
				}
				value.children.forEach((value1, index1) => {
					if(value1.id == val.id) {
						if(value1.is_checked == 0) {
							dataArray[index].children[index1].is_checked = 1;
						}else {
							dataArray[index].children[index1].is_checked = 0;
						}
					}
				});
			});
			that.rzOptions = dataArray;
			let arr1 = [];
			let arr2 = [];
			let arr = [];
			that.rzOptions.forEach((value, index) => {
				if(value.is_checked == 1) {
					arr1.push(value.id);
				}
				value.children.forEach((value1, index1) => {
					if(value1.is_checked == 1) {
						arr2.push(value1.id);
					}
				});
			});
			that.authIds = [...arr1, ...arr2];
			that.noPage1 = 1;
			that.getProductList();
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	.page_box{
		padding: 0 0 30px 0;
		text-align: center;
	}
	/*块3*/
	.block_3{
		padding: 42px 20px 20px 20px;
		.block_3_main{
			position: relative;
			.tags{
				padding: 0 0 0 8px;
				div{
					display: inline-block;
					margin-right: 20px;
					margin-bottom: 24px;
					background: #FFFFFF;
					border-radius: 20px;
					border: 1px solid #0B318F;
					font-size: 16px;
					color: #0B318F;
					padding: 4px 16px 2px 16px;
					cursor: pointer;
				}
				div.actived{
					background-color: #0B318F;
					border: 1px solid #0B318F;
					color: #ffffff;
				}
			}
			.product_list{
				.product_el{
					width: 100%;
					height: auto;
					margin-bottom: 30px;
					padding-bottom: 20px;
					background-color: #F8FAFF;
					border: 1px solid #eaeaea;
					overflow: hidden;
					cursor: pointer;
					.txt{
						padding: 0 15px;
						font-size: 18px;
						color: #706B69;
					}
					.tit_box{
						display: flex;
						padding: 30px 15px 20px 15px;
						.tit{
							flex: 1;
							padding-right: 10px;
							font-size: 20px;
							line-height: 1.5;
						}
						.icon{
							width: 20px;
							margin-top: 10px;
							img{
								width: 100%;
							}
						}
					}
					.bg_box{
						background-color: #ffffff;
						.bg{
							width: 100%;
							height: 260px;
							object-fit: contain;
						}
					}
				}
			}
			.search_list{
				position: absolute;
				top: 90px;
				left: 0;
				width: 100%;
				padding: 20px 0px 0px 0px;
				background-color: #ffffff;
				box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
				z-index: 1;
				.search_list_main{
					.search_el:hover{
						background-color: #F9FAFE;
					}
					.search_el{
						display: flex;
						align-items: center;
						padding: 30px 20px;
						cursor: pointer;
						border-bottom: 1px solid #EFEFEF;
						.search_el_right{
							flex: 1;
							padding-left: 30px;
							.title{
								padding-bottom: 8px;
								font-size: 16px;
								color: #0B318F;
							}
							.text{
								font-size: 14px;
								color: #0B318F;
							}
						}
						.search_el_left{
							width: 125px;
							img{ width: 100%; }
						}
					}
				}
				.top_box{
					display: flex;
					padding: 0px 20px 0px 20px;
					.top_box_left{
						flex: 1;
						font-size: 16px;
					}
					.top_box_right{
						width: auto;
					}
				}
			}
		}
		.input_box{
			padding: 42px 0 24px 0;
			.btn_box{
				width: 100%;
				margin: 10px 0 0 0;
				padding: 4px 0;
				border-radius: 18px;
				background-color: #0066D4;
				display: inline-block;
				cursor: pointer;
				text-align: center;
			}
			input{
				width: 100%;
				height: 50px;
				line-height: 50px;
				border: 1px solid #EFEFEF;
				background-color: #ffffff;
				text-indent: 20px;
				font-size: 16px;
				color: #0B318F;
			}
			input:focus{
				outline: none;
				border: 2px solid #0066D4;
			}
		}
		.cate_box{
			padding: 20px;
			background-color: #EFEFEF;
			.search_box{
				padding: 10px 0 15px 0;
				input{
					width: 100%;
					height: 50px;
					line-height: 50px;
					background-color: #ffffff;
					color: #000000;
					padding-left: 20px;
					border: 1px solid #999999;
				}
			}
			.list_height{
				// height: 8rem;
				// overflow-y: scroll;
			}
			.list_box{
				.list_el{
					padding: 14px 0;
					.list_el_child{
						margin: 18px 0 0 20px;
					}
					.list_el_main{
						font-size: 18px;
						cursor: pointer;
						display: flex;
						.right{
							flex: 1;
							padding-left: 8px;
							line-height: 1.2;
						}
						.left{
							width: 18px;
							img{
								width: 100%;
							}
						}
					}
				}
			}
			.tit{
				padding-bottom: 15px;
				font-size: 20px;
				font-weight: bold;
			}
		}
	}
	/*块2*/
	.block_2{
		padding: 50px 20px;
		background-color: #0B318F;
		.btn_box{
			margin-top: 20px;
			background-color: #F5F8FA;
			color: #0B318F;
		}
		.tit{
			font-size: 24px;
			color: #ffffff;
			text-align: center;
		}
	}
	/*块1*/
	.block_1{
		padding: 22px 0 0 0;
		color: #3D3D3D;
		.bg_box{
			img{ width: 100%; }
		}
		.txt{
			padding: 0 20px 30px 20px;
			font-size: 18px;
		}
		.tit{
			text-align: center;
			padding: 0 20px;
			font-size: 34px;
		}
	}
}
</style>
<style scoped>
>>> .search_list .van-pagination__page-desc{
	display: none;
}
>>> .page_box .el-pager li:hover, >>> .page_box .el-pager li.active{
	color: #0B318F;
}
</style>
